/**
 *
 * SwitchField
 *
 */

import React, { useId } from "react";
import {
  Wrapper,
  Label,
  InputWrapper,
  Input,
  Indicator,
} from "./styledComponents";

const SwitchField = ({
  label,
  checked,
  disabled,
  disabledValue,
  className,
  baseSwitch,
  field,
  form,
  ...props
}) => {
  const value = props.value === "" ? (checked ? checked : false) : props.value;
  const reactId = useId();
  const fieldId = props.id || reactId;
  // Visual + checkbox state follow `checked` when the consumer passes it
  // (BasicInfoForm: `checked={password_required || password}`), otherwise
  // the field value. Using only `value` hid an existing password as off
  // while the click handler still followed the truthy-`checked` branch.
  const isOn = !!(checked || value);

  return (
    <Wrapper>
      {label ? <Label htmlFor={fieldId}>{label}</Label> : null}
      <InputWrapper>
        <Input
          disabled={disabled}
          className={className}
          {...field}
          {...props}
          id={fieldId}
          type="checkbox"
          checked={isOn}
          onChange={
            checked && !baseSwitch
              ? () => {
                  props.clearPassword();
                  props.turnOffPassword();
                }
              : () => props.onChange(props.value ? false : true)
          }
        />
        <Indicator
          aria-hidden="true"
          value={isOn}
          disabled={disabled}
          disabledValue={disabledValue}
          className={className}
        />
      </InputWrapper>
    </Wrapper>
  );
};

export default SwitchField;
